import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var RewardPelletItem = React.memo(function (_a) {
    var id = _a.id, icon = _a.icon, amount = _a.amount;
    if (Long.fromValue(amount).equals(Long.ZERO)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { id: id, className: "reward-pellets-item" },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconLarge },
            React.createElement(Badge, { position: IdBadgePosition.Right },
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: amount, format: TypeNumberFormat.Add })))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/reward-pellets/RewardPelletItem.tsx
// module id = 2323
// module chunks = 3